import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import type {
  AlertType,
  CommonState,
} from "../../../types/states/common.state.type";
import type { TStatusType } from "../../../types/ux/status.ux.type";

const initialState: CommonState = {
  modalStatusHelper: {
    isOpen: false,
    type: undefined,
  },
  modalConfirm: {
    isOpen: false,
    title: undefined,
    message: undefined,
    textButtonNo: "Cancelar",
    textButtonYes: "Aceptar",
    callbackYes: () => {},
    callbackNo: () => {},
  },
  modalAlert: {
    isOpen: false,
    title: undefined,
    message: undefined,
    type: "Success",
    callbackOk: undefined,
  },
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    rxOpenHelperStatusModal: (
      state,
      { payload }: PayloadAction<{ type: TStatusType }>
    ) => {
      state.modalStatusHelper = {
        isOpen: true,
        type: payload.type,
      };
    },

    rxCloseHelperStatusModal: (state) => {
      state.modalStatusHelper = {
        isOpen: false,
        type: state.modalStatusHelper.type,
      };
    },
    rxOpenConfirmModal: (
      state,
      {
        payload,
      }: PayloadAction<{
        title: string;
        message: string;
        callbackYes: VoidFunction;
        callbackNo: VoidFunction;
        textButtonNo: string;
        textButtonYes: string;
      }>
    ) => {
      state.modalConfirm = {
        isOpen: true,
        title: payload.title,
        message: payload.message,
        callbackYes: payload.callbackYes,
        callbackNo: payload.callbackNo,
        textButtonNo: payload.textButtonNo,
        textButtonYes: payload.textButtonYes,
      };
    },
    rxCloseConfirmModal: (state) => {
      state.modalConfirm = {
        ...state.modalConfirm,
        isOpen: false,
      };
    },
    rxOpenAlertModal: (
      state,
      {
        payload,
      }: PayloadAction<{
        title: string;
        message: string;
        type: AlertType;
        callbackOk: VoidFunction;
      }>
    ) => {
      state.modalAlert = {
        isOpen: true,
        title: payload.title,
        message: payload.message,
        type: payload.type,
        callbackOk: payload.callbackOk,
      };
    },
    rxCloseAlertModal: (state) => {
      state.modalAlert = {
        ...state.modalAlert,
        isOpen: false,
      };
    },
  },
});

export const commonSelector = (state: { common: CommonState }) => state.common;

export const {
  rxOpenHelperStatusModal,
  rxCloseHelperStatusModal,
  rxOpenConfirmModal,
  rxCloseConfirmModal,
  rxOpenAlertModal,
  rxCloseAlertModal,
} = commonSlice.actions;
export default commonSlice.reducer;
